/**
 * Composable for managing change review state
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ref } from "vue";
import { approveRejectChange, fetchPendingChanges } from "../../api/changes";
export function useChangeReview() {
    const isLoading = ref(false);
    const error = ref(null);
    const changeRequests = ref([]);
    /**
     * Load all pending change requests
     */
    const loadChangeRequests = (period_1, table_1, ...args_1) => __awaiter(this, [period_1, table_1, ...args_1], void 0, function* (period, table, supervisor = false) {
        isLoading.value = true;
        error.value = null;
        try {
            changeRequests.value = yield fetchPendingChanges({ period, table, supervisor });
        }
        catch (err) {
            error.value = err instanceof Error ? err.message : "Failed to load change requests";
            console.error("Error loading change requests:", err);
            changeRequests.value = [];
        }
        finally {
            isLoading.value = false;
        }
    });
    // /**
    //  * Approve a change request
    //  */
    const approveChange = (changeRequest, comment, table) => __awaiter(this, void 0, void 0, function* () {
        isLoading.value = true;
        error.value = null;
        try {
            const result = yield approveRejectChange({
                changeRequest,
                status: "approved",
                comment,
            }, table);
            if (!result.success) {
                throw new Error(result.message || "Failed to approve change");
            }
            // Remove the approved change from the list
            changeRequests.value = changeRequests.value.filter((cr) => cr.id !== changeRequest.id);
            return result;
        }
        catch (err) {
            error.value = err instanceof Error ? err.message : "Failed to approve change";
            console.error("Error approving change:", err);
            throw err;
        }
        finally {
            isLoading.value = false;
        }
    });
    // /**
    //  * Reject a change request
    //  */
    const rejectChange = (changeRequest, comment, table) => __awaiter(this, void 0, void 0, function* () {
        isLoading.value = true;
        error.value = null;
        try {
            const result = yield approveRejectChange({
                changeRequest,
                status: "rejected",
                comment,
            }, table);
            if (!result.success) {
                throw new Error(result.message || "Failed to reject change");
            }
            // Remove the rejected change from the list
            changeRequests.value = changeRequests.value.filter((cr) => cr.id !== changeRequest.id);
            return result;
        }
        catch (err) {
            error.value = err instanceof Error ? err.message : "Failed to reject change";
            console.error("Error rejecting change:", err);
            throw err;
        }
        finally {
            isLoading.value = false;
        }
    });
    return {
        isLoading,
        error,
        changeRequests,
        loadChangeRequests,
        approveChange,
        rejectChange,
    };
}
